import {Component, Input} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";
import {FamilyAlbum} from "../../../model/family-album";
import {Page} from "../../../model/page";
import {Router} from "@angular/router";
import {UrlService} from "../../../services/url.service";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {BusinessRight} from "../../../model/business-right";

@Component({
  selector: 'event-list',
  template: require('./event-list.component.html'),
  styles: [
    require('./event-list.component.scss')
  ]
})

export class EventListComponent {

  events:FamilyAlbum[] = new Array();
  currentPage:Page<FamilyAlbum>;
  currentPageNumber:number;

  isLoading:boolean = false;

  @Input() userRight: BusinessRight;

  private PAGE_SIZE = 10;

  constructor(private businessService:BusinessService, private router:Router,
              private urlService:UrlService, private currentEventService:CurrentEventService,
              private currentBusinessService:CurrentBusinessService) {

    if (currentBusinessService.currentBusiness == null) {
      currentBusinessService.businessChange$.subscribe(
        business => {
          this.loadEvents(1);
        }
      );
    } else {
      this.loadEvents(1)
    }
  }

  onScroll() {
    if (!this.isLoading && !this.currentPage != null && !this.currentPage.last) {
      this.loadEvents();
    }
  }

  loadEvents(page?:number) {
    this.isLoading = true;

    if (page == null) {
      this.currentPageNumber++;
    } else {
      this.currentPageNumber = page;
    }

    this.businessService.getEvents(this.currentBusinessService.currentBusiness.id, this.currentPageNumber, this.PAGE_SIZE).subscribe(
      page => this.eventsLoaded(page)
    );
  }

  showEvent(event:FamilyAlbum) {
    this.currentEventService.changeEvent(event);
    this.router.navigateByUrl('/event/' + event.id);
  }

  eventsLoaded(page:Page<FamilyAlbum>) {

    if(this.currentPageNumber==1) {
      this.events = [];
    }

    for (let event of page.content) {
      if (event.pictures[0] != null) {
        event.bannerUrl = this.urlService.getPictureMiniatureUrl(event.id, event.pictures[0].id);
        event.bannerHDUrl = this.urlService.getPictureUrl(event.id, event.pictures[0].id);
      }

      this.events.push(event);
    }

    this.currentPage = page;
    this.isLoading = false;
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-list/event-list.component.ts